import React, { useEffect, useState } from "react";
import { Container, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import {useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getSingleProjectById } from "slices/thunk";
import moment from "moment";
import ChatComponent from "../messages/chat";


const LiveContractDetails = () => {
  const [activeTab, setActiveTab] = useState<string>("overview");
  const [searchParams] = useSearchParams();
  const dispatch :any = useDispatch()
  const contractId = searchParams.get("id"); // Get the ID from URL
  const toggle = (tab: string) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  };
  let project: any = null;
  project = useSelector((state: any) => state.Contract.project)
  useEffect(()=>{
if(contractId){
dispatch(getSingleProjectById(contractId))
}
  },[contractId])

  return (
    <React.Fragment>
      <div className="page-content contract-flow-page live-contract-details-page tailwind-prefix">
        <Container fluid>
          {!project? (
  <div className="animate-pulse bg-gray-200 p-5 rounded-lg">
    {/* Title Placeholder */}
    <div className="h-10 bg-gray-300 rounded w-3/4 mb-4"></div>
    
    {/* User Info Placeholder */}
    <div className="flex items-center mt-4">
      <div className="h-12 w-12 bg-gray-300 rounded-full"></div>
      <div className="ml-4">
        <div className="h-4 bg-gray-300 rounded w-32"></div>
        <div className="h-3 bg-gray-300 rounded w-24 mt-2"></div>
      </div>
    </div>

    {/* Tabs Placeholder */}
    <div className="flex mt-6 space-x-8">
      <div className="h-6 bg-gray-300 rounded w-20"></div>
      <div className="h-6 bg-gray-300 rounded w-24"></div>
      <div className="h-6 bg-gray-300 rounded w-32"></div>
    </div>
  </div>
) : (
  <>
    <div style={{
      backgroundColor:'#181A1F',
      padding:20,
      borderRadius:8,
      height:'100%'
    }}>
      <div style={{
          color:'white',
          fontSize:36,
          fontWeight:'500'
      }}>
          {project.p_name}
      </div>
      <div style={{
          display:'flex',
          alignItems:'center',
          marginTop:20
      }}>
        <div>
          <i style={{
              color:'#D9D9D9',
              fontSize:40
          }} className="bi bi-person-circle" />
        </div >
        <div style={{
          marginLeft:10,
          color:'#D9D9D9'
        }}>
          {project.contractor.user_first_name + " " + project.contractor.user_last_name}
          <div style={{
            fontSize:10
          }}>
              {project.contractor.company_name}
          </div>
        </div>
      </div>

      {/* Navigation Tabs */}
      <div style={{ marginTop: 20, borderBottom:'0px solid white' }} className="tflex">
        {["overview", "messages", "details"].map((tab, index) => (
          <NavItem key={tab} style={{ marginLeft: index !== 0 ? 30 : 0 }}>
            <NavLink
              style={{
                color: activeTab === tab ? "#FFFFFF" : "#B0AFAF",
                fontSize: 18,
              }}
              onClick={() => toggle(tab)}
            >
              {tab.charAt(0).toUpperCase() + tab.slice(1)}
              {activeTab === tab && <div style={{ height:1, marginTop:4, backgroundColor:'white' }} />}
            </NavLink>
          </NavItem>
        ))}
      </div>
    </div>

    {/* Tab Contents */}
    <TabContent activeTab={activeTab}>
      <TabPane tabId="overview">
        <OverviewTab project={project}/>
      </TabPane>
      <TabPane tabId="messages">
        <MessagesTab project={project}/>
      </TabPane>
      <TabPane tabId="details">
        <ContractDetailsTab project={project} />
      </TabPane>
    </TabContent>
  </>
)}


        </Container>
      </div>
    </React.Fragment>
  );
};
interface OverviewTabProps {
  project : any;

}
interface recentActity {
  date : any;
  value:any

}
// Dummy Components (Replace with your dataset logic)
const OverviewTab = ({project}:OverviewTabProps) => {
  const milestones = project.milestones
  const projectPrice = project.p_cost 
  
  return <div className="">
  <div style={{
    marginTop:30
  }} className="tbg-gray-100 trounded tp-10"
    >

 
<div className="tgrid tgrid-cols-2 tgrid-cols-desktop-4 tgap-5"> 

<div>
  <div className="ttext-md">
    Total Cost
  </div>
  <div>
 ${project.p_total_cost}
  </div>
</div>
<div>
<div className="ttext-md">
 Project Price
  </div>
  <div>
   ${projectPrice}
  </div>
</div>
<div>
<div className="ttext-md">
  Milestones paid ({milestones.filter((m:any)=> m.pm_is_completed).length})
  </div>
  <div>
   ${milestones.filter((m:any)=> m.pm_is_completed).reduce((sum:any, m:any) => sum + (Number(projectPrice) * Number(m.pm_percentage) / 100), 0)}
  </div>
</div>

<div>
<div className="ttext-md">
  Milestones remaining ({milestones.filter((m:any)=> !m.pm_is_completed).length})
  </div>
  <div>
  ${milestones.filter((m:any)=> !m.pm_is_completed).reduce((sum:any, m:any) => sum + (Number(projectPrice) * Number(m.pm_percentage) / 100), 0)}

  </div>
</div>
  </div>



   
 
   
    </div>

    <div className="tm-t-40 tm-l-4"> 
      <div className="tfont-normal text-black ttext-xl">
        Milestone timeline
      </div>

<div className="tm-t-32">
{milestones.map((m:any,index:any) =>{
  const price = Number(projectPrice)/Number( m.pm_percentage)
        return (
          <div style={{
            alignItems:'start',
            display:'flex',
            height:145,
            flexDirection:'row'
          }} className="tflex   ">
            <div style={{
                display:'flex',
                flexDirection:'column',
                alignItems:'center',
                justifyContent:'center'
              }} className="">
              <div   className="">
              {!m.pm_is_completed ?  <i style={{
                display:'flex',
                justifyContent:'center',
                alignItems:'center'
              }}  className="bi  bi-x-circle ttext-gray-600 ttext-2xl " />: <i className="bi bi-check-circle ttext-2xl " />}

              </div>
              {index+1 < milestones.length &&          <div style={{
                height:120,
                width:1,
                backgroundColor:'gray'
              }}>

              </div>}
     
             
            </div>
  <div className="tp-l-10  ">
           
           <div className="ttext-lsm ">
           {m.pm_name} -   {m.pm_percentage}%

           </div>
           <div className="tm-t-10">
         <div className="tm-b-10"> 
         <div className="ttext-gray-600">
          {m.pm_is_completed_by_homeowner?"Completed by homeowner ":'Not Completed by homeowner '}
         </div>
         <div className="ttext-gray-600">
          {m.pm_is_completed_by_inspector?"Completed by inspector ":"Not Completed by inspector "}
         </div>
         </div>
           </div>
           <div style={{
            alignItems:"center",
            display:'flex',
            justifyContent:'start'
           }} className="ttext-lsm tflex tm-t-3"> 
            <div>
            ${price.toFixed(2)}

            </div>

            <div style={{
              textAlign:'center'
            }} className="ttext-sm  tp-l-10 tp-r-10 tp-t-5 tp-b-5   trounded-sm tm-l-10  tbg-gray-600  ttext-gray-200  ">

              Un-Paid
            </div>
           </div>
          </div>
          </div>
        
        )
      })}
</div>
  
    </div>
  </div>;
};

const MessagesTab = ({project}:OverviewTabProps) => {
  return <div style={{
  }}><ChatComponent project={project}/></div>;
};

const ContractDetailsTab = ({project}:OverviewTabProps) => {
  if(!project.contract){
    return null
  }
  return <div className="p-3">
    <div>

    <div className="ttext-2xl ttext-black">
      Description 
    </div>
  
  <div className="tm-t-20">
{project.contract.pc_work_description}
  </div>
  </div>


  <div className="tm-t-32">
  <div className="ttext-2xl ttext-black">
      Summary 
    </div>

    <div style={{
      borderBottom:'1px solid #d1d5db'
    }} className="tflex tm-t-20 tp-b-10 tflex-justify-between  ">
<div className="ttext-md  ttext-gray-500">
Is Escrow
</div>
<div className="ttext-md ">
  {project.p_escrow ===1 ?"Yes":'No'}
</div>
    </div>

    <div style={{
      borderBottom:'1px solid #d1d5db'
    }} className="tflex tm-t-20 tp-b-10 tflex-justify-between  ">
<div className="ttext-md  ttext-gray-500">
Start Date
</div>
<div className="ttext-md ">
  {moment(project.p_created_at).format("MMM DD, YYYY")  }
</div>
    </div>
  
  </div>

  

  <div style={{
    border:'1px solid #d1d5db'
  }} className="tm-t-32 trounded-sm tp-20 ">
  <div className="ttext-xl ttext-black">
      Company information 
    </div>

    <div style={{
      borderBottom:'1px solid #d1d5db'
    }} className="tflex tm-t-20 tp-b-10 tflex-justify-between  ">
<div className="ttext-md  ttext-gray-500">
User ID
</div>
<div className="ttext-md ">
  {project.contractor.user_id }
</div>
    </div>

    <div style={{
      borderBottom:'1px solid #d1d5db'
    }} className="tflex tm-t-20 tp-b-10 tflex-justify-between  ">
<div className="ttext-md  ttext-gray-500">
User Name
</div>
<div className="ttext-md ">
  {project.contractor.user_first_name + " " + project.contractor.user_last_name }
</div>
    </div>

    <div style={{
      borderBottom:'1px solid #d1d5db'
    }} className="tflex tm-t-20 tp-b-10 tflex-justify-between  ">
<div className="ttext-md  ttext-gray-500">
Company Name
</div>
<div className="ttext-md ">
  {project.contractor.company_name  }
</div>
    </div>
  
  </div>


  <div className="tm-t-32">
  <div className="ttext-2xl ttext-black">
      Recent activity 
    </div>

    <div style={{
      borderBottom:'1px solid #d1d5db'
    }} className="tflex tm-t-20 tp-b-10 tflex-justify-start  ">
<div style={{
  width:140
}} className="ttext-md  ttext-gray-500">
Date
</div>
<div className="ttext-md ttext-gray-500">
  Description
</div>
    </div>
   

<RecentActivity  date={project.subcontractors[0].ps_created_at} value={<div>Subcontractor added  <label className="ttext-blue">{project.subcontractors[0].user_first_name}</label></div>} />
<RecentActivity  date={project.contract.pc_additional_homeowner_signed_at} value={<div className="ttext-sm ">
additional Homeowner  <label className="ttext-blue">{project.contract.pc_additional_home_owner_name}</label> Signed the contract
</div>} />
<RecentActivity  date={project.contract.pc_homeowner_signed_at} value={<div className="ttext-sm ">
Home owner <label className="ttext-blue">{project.contract.pc_homeowner_id}</label> Signed the contract
</div>} />
<RecentActivity  date={project.contract.pc_contractor_signed_at} value={<div className="ttext-sm ">
Contractor <label className="ttext-blue">{project.contractor.user_first_name}</label> Signed the contract
</div>} />

<RecentActivity  date={project.contract.pc_contract_created_at} value={<div className="ttext-sm ">
Contract Created 
</div>} />

<RecentActivity  date={project.contract.pc_created_at} value={<div className="ttext-sm">
You created this project <label className="tfont-normal ttext-blue">
{project.p_name}
  </label> 
</div>} />

  
  </div>

  </div>;
};




export default LiveContractDetails;
function RecentActivity({date,value}:recentActity) {
  if(!date){
    return null
  }
  return <div style={{
    borderBottom: '1px solid #d1d5db'
  }} className="tflex tm-t-20 tp-b-10 tflex-justify-start  ">
    <div style={{
      width: 140
    }} className="ttext-sm  ttext-gray-700">
      {moment(date).format("MMM DD, YYYY")}
    </div>
    <div className="ttext-sm ">
      {value}
    </div>
  </div>;
}
